// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-white/banner-mid-page-white.component.scss
// module id = 142
// module chunks = 0